import { application, loadStimulusDefinitionsFromContexts } from "../../lib/stimulus";

loadStimulusDefinitionsFromContexts(application, require.context(".", true, /_controller\.js$/));

